import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import CitasTalleres from '../../Components/Coordinador/CitasTalleres/CitasTalleres';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';
import { puedeVerMenu } from '../../Helpers/rolesPermisos';
import '../../Components/Coordinador/Citas.css';

export default function CitasTalleresPage() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    
    const puedeVerCitasTalleres = () => {
        if (!puedeVerMenu(usuarioLegued?.rol, 'citas-talleres')) return false;
        if (usuarioLegued?.rol !== 'terapeuta') return true;
        return Number(usuarioLegued?.permite_grupal) === 1;
    };

    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container2'>
                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {puedeVerCitasTalleres() ? (
                                <CitasTalleres />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <SinPermisos />
                    )}
                </div>
            </section>
        </div>
    );
}
